import { isBrowser } from './isBrowser';

export function isInIframe() {
  if (!isBrowser()) return false;

  try {
    // Do not show cypress tests as in iFrame
    if (
      // @ts-ignore Cypress will be on window if we are in a test
      window.top?.Cypress !== undefined ||
      // @ts-ignore __STORYBOOK_ADDONS will be on window if we are in storybook
      window.top?.__STORYBOOK_ADDONS !== undefined
    )
      return false;

    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}
